import {
  AutoCompleteSearchUsersInProgress,
  AutoCompleteSearchUsersSuccess,
  AutoCompleteSearchUsersFailure,
  AutoCompleteSearchUsersClear
} from "../state/autocomplete/actions";
import { oktaAuth } from '../auth/okta';
const serverBasePath=process.env.REACT_APP_SERVER_API_URL;

let abortController = null;

export const searchUsers = (query) => {
  return async (dispatch) => {

    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token');

    if (abortController) {
      abortController.abort();
    }

    abortController = new AbortController();
    const signal = abortController.signal;

    dispatch(AutoCompleteSearchUsersInProgress());

    try {
      const response = await fetch(
        `${serverBasePath}/user/getSearchUsers?search=${encodeURIComponent(query)}`,
        { 
            signal,
            method: "GET",    
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json', 
            }
        });
      if (!response.ok) {
        throw new Error("Failed");
      }
      const result = await response.json();
      dispatch(AutoCompleteSearchUsersSuccess(result?.data));
    } catch (error) {
      if (error.name === "AbortError") {
        return;
      }
      dispatch(AutoCompleteSearchUsersFailure());
    }
  };
};

export const clearAutocomplete = () => async (dispatch) => {
  dispatch(AutoCompleteSearchUsersClear());
};
